//--- React
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
//--- Ant Design
import { Col, Row } from "antd";
//--- Project
import "../styles.css";
import { useRequiredAccess } from "hooks/useRequiredAccess";
import { getCompanyDateRange } from "apis/competitorPulseApis";
import { ORG_TYPES } from "components/Common/Constants";
import ReviewList from "./ReviewList";
import ReviewAnalysis from "./ReviewAnalysis";
import CompanyFilter from "./CompanyFilter";
import { secondaryColor } from "../constants";

const MarketPulseFeedback = ({ selectedCompany,selectedSentiment, companiesList, companiesLoading }) => {
  const [filterValue, setFilterValue] = useState({
    company: null,
    minDate: null,
    maxDate: null,
    startDate: null,
    endDate: null,
    sourceList: null,
    bikeModel: null,
    sentiment: null,
  });
  const [subCatgryColor, setSubCatgryColor] = useState({});
  const [reviewCount, setReviewCount] = useState(0);

  const checkAccess = useRequiredAccess([], [ORG_TYPES.ADMINISTRATOR]);

  useEffect(() => {
    checkAccess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    data: companyReviewData,
    isLoading: companyReviewDataLoading,
    isError: companyReviewDataIsError,
    error: companyReviewDataError,
  } = useQuery({
    queryKey: [
      "ReviewCount",
      filterValue.company,
      filterValue.startDate,
      filterValue.endDate,
    ],
    queryFn: () =>
      getCompanyDateRange(
        filterValue.company,
        Math.floor(filterValue.startDate / 1000),
        Math.floor(filterValue.endDate / 1000)
      ),
    keepPreviousData: true,
    enabled: !!(
      filterValue.company &&
      filterValue.startDate &&
      filterValue.endDate
    ),
    refetchOnWindowFocus: false,
  });

  const onFilterChange = (name, value, total) => {
    if (name === "company") {
      setFilterValue({
        ...value,
        minDate: value.min_date * 1000,
        maxDate: value.max_date * 1000,
        startDate: value.min_date * 1000,
        endDate: value.max_date * 1000,
      });
    } else if (name === "dates") {
      setFilterValue((prev) => ({
        ...prev,
        startDate: value[0],
        endDate: value[1],
        sourceList: null,
        bikeModel: null,
        sentiment: null,
        category: null,
        subCategory: null,
      }));
    } else if (["sourceList", "bikeModel"].includes(name)) {
      const [firstColumn, ...otherColumns] = value;
      const selectedColumn =
        !value?.length ||
        otherColumns.at(-1) === null ||
        value.filter((item) => item !== null).length === total
          ? null
          : firstColumn === null
          ? otherColumns
          : value;
      setFilterValue((prev) => ({
        ...prev,
        [name]: selectedColumn,
        category: null,
        subCategory: null,
      }));
    } else if (name === "sentiment") {
      setFilterValue((prev) => ({
        ...prev,
        [name]: value,
        category: null,
        subCategory: null,
      }));
    } else if (name === "category") {
      setFilterValue((prev) => ({
        ...prev,
        subCategory: null,
        [name]: prev.category === value ? null : value,
      }));
    } else {
      setFilterValue((prev) => ({ ...prev, subCategory: null, [name]: value }));
    }
  };

  return (
    <Row justify={"center"} className="competitor-pulse-page h100vh">
      <Col span={24}>
        <CompanyFilter
          selectedCompany={selectedCompany}
          filterValue={filterValue}
          setFilterValue={setFilterValue}
          onFilterChange={onFilterChange}
          companyReviewData={companyReviewData}
          companiesList={companiesList}
          companiesLoading={companiesLoading}
          selectedSentiment={selectedSentiment}
        />
      </Col>
      <Col span={24} className="mt1">
        <ReviewAnalysis
          reviewCount={reviewCount}
          filterValue={filterValue}
          onFilterChange={onFilterChange}
          companyReviewData={companyReviewData}
          companyReviewDataLoading={companyReviewDataLoading}
          companyReviewDataIsError={companyReviewDataIsError}
          companyReviewDataError={companyReviewDataError}
          selectedColor={secondaryColor}
          setSubCatgryColor={setSubCatgryColor}
          selectedSentiment={selectedSentiment} 
        />
      </Col>
      <Col span={24} className="mt1">
        <ReviewList
          filterValue={filterValue}
          subCatgryColor={subCatgryColor}
          setReviewCount={setReviewCount}
        />
      </Col>
    </Row>
  );
};

export default MarketPulseFeedback;
